import { useState } from "react";
import { Table, Space, Button, Tooltip, Popconfirm, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function BodegasTable({ data, loading, onEdit, onDelete, permissionUpdate, permissionDelete }) {

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  });

  const handleTableChange = (paginationInfo) => {
    setPagination(paginationInfo);
  };

  const renderTextWrap = (value, width = 220) => (
    <Text
      style={{
        display: "block",
        maxWidth: width,
        whiteSpace: "normal",
        wordBreak: "break-word"
      }}
    >
      {value}
    </Text>
  );

  const columns = [
    {
      title: "Organización",
      dataIndex: "organizacion_nombre",
      width: 280,
      render: (text) => renderTextWrap(text, 280)
    },
    {
      title: "Sigla",
      dataIndex: "sigla",
      width: 160
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      width: 160
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      width: 160
    },
    {
      title: "Responsable",
      dataIndex: "responsable_nombre",
      width: 200
    },
    {
      title: "Acciones",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Space>

          {permissionUpdate && (
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record)}
              />
            </Tooltip>
          )}

          {permissionDelete && (
            <Popconfirm
              title="¿Eliminar bodega?"
              okText="Eliminar"
              cancelText="Cancelar"
              onConfirm={() => onDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}

        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="oid"
      columns={columns}
      dataSource={data}
      loading={loading}
      bordered
      size="middle"
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total) => `Total ${total} bodegas`
      }}
      onChange={handleTableChange}
      style={{
        borderRadius: 8,
        overflow: "hidden"
      }}
    />
  );
}
